/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Liable_Driver_TitleInputs */

const en_case_section_liable_driver_title = /** @type {(inputs: Case_Section_Liable_Driver_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liable driver`)
};

const pt_br2_case_section_liable_driver_title = /** @type {(inputs: Case_Section_Liable_Driver_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motorista terceiro`)
};

/**
* | output |
* | --- |
* | "Liable driver" |
*
* @param {Case_Section_Liable_Driver_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_liable_driver_title = /** @type {((inputs?: Case_Section_Liable_Driver_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Liable_Driver_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_liable_driver_title(inputs)
	return pt_br2_case_section_liable_driver_title(inputs)
});